export default __webpack_public_path__ + "media/titles/title_5_locale_it-5cbd6b8f.png";